module.exports = __webpack_public_path__ + "assets/img/202108-1W.b671cf06.png";